/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any; }
};

export enum BagCyclesEnum {
  EightyOneToTwoHundred = 'EightyOneToTwoHundred',
  OneToEighty = 'OneToEighty',
  TwoHundredPlus = 'TwoHundredPlus'
}

export type BagNode = Node & {
  __typename?: 'BagNode';
  /** This is the QR code/NFC tag ID of the chip in the bag. */
  bagId: Scalars['String']['output'];
  /** This is the id of the box the chip was shipped in. */
  boxId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cycles?: Maybe<Scalars['Int']['output']>;
  /** The RFID EPC ID of the chip in the bag. */
  epcId?: Maybe<Scalars['String']['output']>;
  /** This is the human readable ID of the bag. It's the the last 6 characters of the bag_id */
  humanReadableId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastScannedAt?: Maybe<Scalars['DateTime']['output']>;
  numberOfBagShipments?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<BusinessNode>;
  retiredAt?: Maybe<Scalars['DateTime']['output']>;
  retiredBy?: Maybe<UserNode>;
  retiredReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scanEvents: ScanEventNodeConnection;
  /** This is the id of the small carton the chip was shipped in. */
  smallCartonId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** The RFID TID ID of the chip in the bag. */
  tidId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type BagNodeScanEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BagNodeConnection = {
  __typename?: 'BagNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BagNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BagNode` and its cursor. */
export type BagNodeEdge = {
  __typename?: 'BagNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BagNode>;
};

export enum BagStatusSchema {
  Destroyed = 'DESTROYED',
  Ok = 'OK',
  Repair = 'REPAIR'
}

export type BusinessNode = Node & {
  __typename?: 'BusinessNode';
  address: Scalars['String']['output'];
  bags: BagNodeConnection;
  co2ReductionPerKiloWaste: Scalars['Float']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  locations: LocationNodeConnection;
  name: Scalars['String']['output'];
  numberOfBusinessShipments?: Maybe<Scalars['Int']['output']>;
  postalCode: Scalars['String']['output'];
  postalTown: Scalars['String']['output'];
  scanEvents: ScanEventNodeConnection;
  /** Locations that are associated with this business where could scan bags. */
  scanLocations?: Maybe<Array<LocationNode>>;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserNodeConnection;
  wasteReductionPerCycle: Scalars['Float']['output'];
};


export type BusinessNodeBagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BusinessNodeLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BusinessNodeScanEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BusinessNodeUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessNodeConnection = {
  __typename?: 'BusinessNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BusinessNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BusinessNode` and its cursor. */
export type BusinessNodeEdge = {
  __typename?: 'BusinessNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BusinessNode>;
};

export type ChangePasswordMutation = {
  __typename?: 'ChangePasswordMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<UserNode>;
};

export type CheckResetPasswordToken = {
  __typename?: 'CheckResetPasswordToken';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfirmResetPasswordMutation = {
  __typename?: 'ConfirmResetPasswordMutation';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserNode>;
};

export type CouponNode = Node & {
  __typename?: 'CouponNode';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedToUser?: Maybe<UserNode>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
  vendor: Scalars['String']['output'];
};

export type CouponNodeConnection = {
  __typename?: 'CouponNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CouponNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CouponNode` and its cursor. */
export type CouponNodeEdge = {
  __typename?: 'CouponNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CouponNode>;
};

export type CreateBagInput = {
  /** This is the QR code/NFC tag ID of the chip in the bag. */
  bagId?: InputMaybe<Scalars['String']['input']>;
  /** This is the id of the box the chip was shipped in. */
  boxId?: InputMaybe<Scalars['String']['input']>;
  /** The RFID EPC ID of the chip in the bag. */
  epcId?: InputMaybe<Scalars['String']['input']>;
  /** This is the human readable ID of the bag. It's the the last 6 characters of the bag_id */
  humanReadableId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  retiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  retiredBy?: InputMaybe<Scalars['ID']['input']>;
  retiredReasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** This is the id of the small carton the chip was shipped in. */
  smallCartonId?: InputMaybe<Scalars['String']['input']>;
  /** The RFID TID ID of the chip in the bag. */
  tidId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBagMutation = {
  __typename?: 'CreateBagMutation';
  bag?: Maybe<BagNode>;
};

export type CreateBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  co2ReductionPerKiloWaste?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalTown?: InputMaybe<Scalars['String']['input']>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteReductionPerCycle?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateBusinessMutation = {
  __typename?: 'CreateBusinessMutation';
  business?: Maybe<BusinessNode>;
};

export type CreateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  closingHour?: InputMaybe<Scalars['Time']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  freightPartner?: InputMaybe<LocationsLocationFreightPartnerChoices>;
  googleLocationId?: InputMaybe<Scalars['String']['input']>;
  hasOpeningHours?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHour?: InputMaybe<Scalars['Time']['input']>;
  openingHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalTown?: InputMaybe<Scalars['String']['input']>;
  printerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  ratings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  returns?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Freight partner service location id. */
  servicePointId?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationsLocationTypeChoices>;
  usedCapacity?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateLocationMutation = {
  __typename?: 'CreateLocationMutation';
  location?: Maybe<LocationNode>;
};

export type CreateRatingInput = {
  location?: InputMaybe<Scalars['ID']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateRatingMutation = {
  __typename?: 'CreateRatingMutation';
  rating?: Maybe<RatingNode>;
};

export type CreateReturnHistoryInput = {
  /** Latitude of the person returning the bag. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location: Scalars['ID']['input'];
  /** Longitude of the person returning the bag. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The scanned ID of the returned package. */
  packageId: Scalars['String']['input'];
  packageSize?: InputMaybe<Scalars['Int']['input']>;
  user: Scalars['ID']['input'];
};

export type CreateReturnHistoryMutation = {
  __typename?: 'CreateReturnHistoryMutation';
  returnHistory?: Maybe<ReturnHistoryNode>;
};

export type CreateScanEventMutation = {
  __typename?: 'CreateScanEventMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  scanEvent?: Maybe<ScanEventNode>;
};

export type DashboardAnalyticsResult = {
  __typename?: 'DashboardAnalyticsResult';
  /** Monthly CO2 and waste reductions. Sorted chronologically */
  monthlyStats?: Maybe<Array<Maybe<MonthlyReductionResult>>>;
  parcelsCycled?: Maybe<Scalars['Int']['output']>;
  totalBags?: Maybe<Scalars['Int']['output']>;
  totalCo2Reduction?: Maybe<Scalars['Float']['output']>;
  totalWasteReduction?: Maybe<Scalars['Float']['output']>;
};

export type DeleteBagMutation = {
  __typename?: 'DeleteBagMutation';
  deletedId?: Maybe<Scalars['ID']['output']>;
  deletedInputId?: Maybe<Scalars['ID']['output']>;
  deletedRawId?: Maybe<Scalars['ID']['output']>;
  found?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBusinessMutation = {
  __typename?: 'DeleteBusinessMutation';
  deletedId?: Maybe<Scalars['ID']['output']>;
  deletedInputId?: Maybe<Scalars['ID']['output']>;
  deletedRawId?: Maybe<Scalars['ID']['output']>;
  found?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLocationMutation = {
  __typename?: 'DeleteLocationMutation';
  deletedId?: Maybe<Scalars['ID']['output']>;
  deletedInputId?: Maybe<Scalars['ID']['output']>;
  deletedRawId?: Maybe<Scalars['ID']['output']>;
  found?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReturnHistoryMutation = {
  __typename?: 'DeleteReturnHistoryMutation';
  deletedId?: Maybe<Scalars['ID']['output']>;
  deletedInputId?: Maybe<Scalars['ID']['output']>;
  deletedRawId?: Maybe<Scalars['ID']['output']>;
  found?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteScanEventMutation = {
  __typename?: 'DeleteScanEventMutation';
  deletedId?: Maybe<Scalars['ID']['output']>;
  deletedInputId?: Maybe<Scalars['ID']['output']>;
  deletedRawId?: Maybe<Scalars['ID']['output']>;
  found?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserMutation = {
  __typename?: 'DeleteUserMutation';
  deletedId?: Maybe<Scalars['ID']['output']>;
  deletedInputId?: Maybe<Scalars['ID']['output']>;
  deletedRawId?: Maybe<Scalars['ID']['output']>;
  found?: Maybe<Scalars['Boolean']['output']>;
};

export type DistanceObject = {
  __typename?: 'DistanceObject';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum LastScannedAtEnum {
  EightyDaysPlus = 'EightyDaysPlus',
  FortyOneToEightyDays = 'FortyOneToEightyDays',
  OneToFortyDays = 'OneToFortyDays'
}

export type LocationNode = Node & {
  __typename?: 'LocationNode';
  address: Scalars['String']['output'];
  availableCapacity?: Maybe<Scalars['String']['output']>;
  business?: Maybe<BusinessNode>;
  closingHour?: Maybe<Scalars['Time']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  distanceFromCurrentLocation?: Maybe<Scalars['Int']['output']>;
  formattedAddress: Scalars['String']['output'];
  freightPartner?: Maybe<LocationsLocationFreightPartnerChoices>;
  googleLocationId: Scalars['String']['output'];
  hasOpeningHours: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maxCapacity: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfBagShipments?: Maybe<Scalars['Int']['output']>;
  numberOfScansToday?: Maybe<ScanEventsPerDayNode>;
  numberScansTodayPerBusiness?: Maybe<Array<Maybe<ScanDataPerBusinessNode>>>;
  openingHour?: Maybe<Scalars['Time']['output']>;
  openingHours?: Maybe<Array<Maybe<OpeningHoursNode>>>;
  postalCode: Scalars['String']['output'];
  postalTown: Scalars['String']['output'];
  printerStatus: Scalars['Boolean']['output'];
  rating?: Maybe<Scalars['String']['output']>;
  ratings: RatingNodeConnection;
  returns: ReturnHistoryNodeConnection;
  scanEvents: ScanEventNodeConnection;
  /** Freight partner service location id. */
  servicePointId: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  type: LocationsLocationTypeChoices;
  updatedAt: Scalars['DateTime']['output'];
  usedCapacity: Scalars['Int']['output'];
  user: UserNodeConnection;
};


export type LocationNodeDistanceFromCurrentLocationArgs = {
  currentLatitude?: InputMaybe<Scalars['Float']['input']>;
  currentLongitude?: InputMaybe<Scalars['Float']['input']>;
};


export type LocationNodeNumberOfScansTodayArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};


export type LocationNodeRatingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationNodeReturnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationNodeScanEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationNodeUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationNodeConnection = {
  __typename?: 'LocationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LocationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LocationNode` and its cursor. */
export type LocationNodeEdge = {
  __typename?: 'LocationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LocationNode>;
};

export type LocationWithExtraLocationInfo = {
  __typename?: 'LocationWithExtraLocationInfo';
  distance?: Maybe<DistanceObject>;
  duration?: Maybe<DistanceObject>;
  location?: Maybe<LocationNode>;
};

/** An enumeration. */
export enum LocationsLocationFreightPartnerChoices {
  /** Postnord */
  Postnord = 'POSTNORD'
}

/** An enumeration. */
export enum LocationsLocationTypeChoices {
  /** Maintenance point */
  MaintenancePoint = 'MAINTENANCE_POINT',
  /** Return point */
  ReturnPoint = 'RETURN_POINT',
  /** Store point */
  StorePoint = 'STORE_POINT',
  /** Warehouse point */
  WarehousePoint = 'WAREHOUSE_POINT'
}

/** An enumeration. */
export enum LocationsOpeningHoursClosingDayChoices {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY'
}

/** An enumeration. */
export enum LocationsOpeningHoursOpeningDayChoices {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY'
}

export type LoginMutation = {
  __typename?: 'LoginMutation';
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserNode>;
};

export type MonthlyReductionResult = {
  __typename?: 'MonthlyReductionResult';
  co2Reduction?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  wasteReduction?: Maybe<Scalars['Float']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changePassword?: Maybe<ChangePasswordMutation>;
  checkResetPasswordToken?: Maybe<CheckResetPasswordToken>;
  confirmResetPassword?: Maybe<ConfirmResetPasswordMutation>;
  createBag?: Maybe<CreateBagMutation>;
  createBusiness?: Maybe<CreateBusinessMutation>;
  createLocation?: Maybe<CreateLocationMutation>;
  createRating?: Maybe<CreateRatingMutation>;
  createReturnHistory?: Maybe<CreateReturnHistoryMutation>;
  createScanEvent?: Maybe<CreateScanEventMutation>;
  deleteBag?: Maybe<DeleteBagMutation>;
  deleteBusiness?: Maybe<DeleteBusinessMutation>;
  deleteLocation?: Maybe<DeleteLocationMutation>;
  deleteReturnHistory?: Maybe<DeleteReturnHistoryMutation>;
  deleteScanEvent?: Maybe<DeleteScanEventMutation>;
  deleteUser?: Maybe<DeleteUserMutation>;
  login?: Maybe<LoginMutation>;
  patchBusiness?: Maybe<PatchBusinessMutation>;
  patchUser?: Maybe<PatchUserMutation>;
  registerUser?: Maybe<RegisterUserMutation>;
  resetPassword?: Maybe<ResetPasswordMutation>;
  retireBag?: Maybe<RetireBagMutation>;
  updateBag?: Maybe<UpdateBagMutation>;
  updateBusiness?: Maybe<UpdateBusinessMutation>;
  /**
   * Called from the frontend after a user has logged in, e.g. via OAuth and a JWT
   * has been returned from the third party.
   *
   * The only purpose of this mutation is to set "last_login" on the user.
   */
  updateLastLogin?: Maybe<UpdateLastLoginMutation>;
  updateLocation?: Maybe<UpdateLocationMutation>;
  updateReturnHistory?: Maybe<UpdateReturnHistoryMutation>;
  updateScanEvent?: Maybe<UpdateScanEventMutation>;
  /** Specific mutation users in warehouses can use to register a circulated bag. */
  warehouseCreateScanEvent?: Maybe<WarehouseCreateScanEventMutation>;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCheckResetPasswordTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationConfirmResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCreateBagArgs = {
  input: CreateBagInput;
};


export type MutationCreateBusinessArgs = {
  input: CreateBusinessInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateRatingArgs = {
  input: CreateRatingInput;
};


export type MutationCreateReturnHistoryArgs = {
  input: CreateReturnHistoryInput;
};


export type MutationCreateScanEventArgs = {
  bagId: Scalars['String']['input'];
  bagStatus?: InputMaybe<BagStatusSchema>;
  deviceLatitude?: InputMaybe<Scalars['Float']['input']>;
  deviceLongitude?: InputMaybe<Scalars['Float']['input']>;
  enableOrderShipment?: InputMaybe<Scalars['Boolean']['input']>;
  selectedLocation?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteBagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBusinessArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReturnHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScanEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationPatchBusinessArgs = {
  id: Scalars['ID']['input'];
  input: PatchBusinessInput;
};


export type MutationPatchUserArgs = {
  id: Scalars['ID']['input'];
  input: PatchUserInput;
};


export type MutationRegisterUserArgs = {
  acceptedTerms: Scalars['Boolean']['input'];
  allowMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneNumberPrefix: Scalars['String']['input'];
  role: UserRole;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationRetireBagArgs = {
  id: Scalars['ID']['input'];
  reasons: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdateBagArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBagInput;
};


export type MutationUpdateBusinessArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBusinessInput;
};


export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLocationInput;
};


export type MutationUpdateReturnHistoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateReturnHistoryInput;
};


export type MutationUpdateScanEventArgs = {
  id: Scalars['ID']['input'];
  input: UpdateScanEventInput;
};


export type MutationWarehouseCreateScanEventArgs = {
  bagId: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type OpeningHoursNode = Node & {
  __typename?: 'OpeningHoursNode';
  closingDay: LocationsOpeningHoursClosingDayChoices;
  closingTime: Scalars['Time']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  location?: Maybe<LocationNode>;
  openingDay: LocationsOpeningHoursOpeningDayChoices;
  openingTime: Scalars['Time']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PatchBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  co2ReductionPerKiloWaste?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalTown?: InputMaybe<Scalars['String']['input']>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteReductionPerCycle?: InputMaybe<Scalars['Float']['input']>;
};

export type PatchBusinessMutation = {
  __typename?: 'PatchBusinessMutation';
  business?: Maybe<BusinessNode>;
};

export type PatchUserInput = {
  acceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  allowMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  coupons?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateJoined?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Designates whether the user can log into this admin site. */
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  logentrySet?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberPrefix?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  ratings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  retiredBags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  returns?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scopedPermissionGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scopedPermissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Specific permissions for this user. */
  userPermissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PatchUserMutation = {
  __typename?: 'PatchUserMutation';
  user?: Maybe<UserNode>;
};

export type Query = {
  __typename?: 'Query';
  allBags?: Maybe<BagNodeConnection>;
  allBusiness?: Maybe<BusinessNodeConnection>;
  allEvents?: Maybe<ScanEventNodeConnection>;
  allLocations?: Maybe<LocationNodeConnection>;
  allLocationsWithDistance?: Maybe<Array<Maybe<LocationWithExtraLocationInfo>>>;
  allMyBusinessLocations?: Maybe<Array<Maybe<LocationNode>>>;
  allUsers?: Maybe<UserNodeConnection>;
  bag?: Maybe<BagNode>;
  bagByChipId?: Maybe<BagNode>;
  business?: Maybe<BusinessNode>;
  coupon?: Maybe<CouponNode>;
  dashboardAnalytics?: Maybe<DashboardAnalyticsResult>;
  event?: Maybe<ScanEventNode>;
  iHavePermission?: Maybe<Scalars['Boolean']['output']>;
  iHavePermissions?: Maybe<Scalars['Boolean']['output']>;
  isLoggedIn?: Maybe<Scalars['Boolean']['output']>;
  killSwitchUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationNode>;
  me?: Maybe<UserNode>;
  minimumAppVersion?: Maybe<Scalars['Int']['output']>;
  myReturnHistory?: Maybe<ReturnHistoryNodeConnection>;
  returnHistory?: Maybe<ReturnHistoryNode>;
  scanEvents?: Maybe<Array<Maybe<ScanEventNode>>>;
  user?: Maybe<UserNode>;
};


export type QueryAllBagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cycles?: InputMaybe<Array<InputMaybe<BagCyclesEnum>>>;
  cyclesGt?: InputMaybe<Scalars['Int']['input']>;
  cyclesLt?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastScannedAt?: InputMaybe<Array<InputMaybe<LastScannedAtEnum>>>;
  lastScannedAtGt?: InputMaybe<Scalars['DateTime']['input']>;
  lastScannedAtLt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  retired?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllBusinessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latitude_Gt?: InputMaybe<Scalars['Float']['input']>;
  latitude_Gte?: InputMaybe<Scalars['Float']['input']>;
  latitude_Lt?: InputMaybe<Scalars['Float']['input']>;
  latitude_Lte?: InputMaybe<Scalars['Float']['input']>;
  longitude_Gt?: InputMaybe<Scalars['Float']['input']>;
  longitude_Gte?: InputMaybe<Scalars['Float']['input']>;
  longitude_Lt?: InputMaybe<Scalars['Float']['input']>;
  longitude_Lte?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllLocationsWithDistanceArgs = {
  currentLatitude: Scalars['Float']['input'];
  currentLongitude: Scalars['Float']['input'];
};


export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBagByChipIdArgs = {
  bagId: Scalars['String']['input'];
};


export type QueryBusinessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDashboardAnalyticsArgs = {
  businessId: Scalars['ID']['input'];
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIHavePermissionArgs = {
  permission: Scalars['String']['input'];
};


export type QueryIHavePermissionsArgs = {
  permissions: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyReturnHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReturnHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScanEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type RatingNode = Node & {
  __typename?: 'RatingNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  location?: Maybe<LocationNode>;
  rating?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserNode>;
};

export type RatingNodeConnection = {
  __typename?: 'RatingNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RatingNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RatingNode` and its cursor. */
export type RatingNodeEdge = {
  __typename?: 'RatingNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RatingNode>;
};

export type RegisterUserMutation = {
  __typename?: 'RegisterUserMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserNode>;
};

export type ResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RetireBagMutation = {
  __typename?: 'RetireBagMutation';
  bag?: Maybe<BagNode>;
};

export type ReturnHistoryNode = Node & {
  __typename?: 'ReturnHistoryNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Latitude of the person returning the bag. */
  latitude?: Maybe<Scalars['Float']['output']>;
  location: LocationNode;
  /** Longitude of the person returning the bag. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The scanned ID of the returned package. */
  packageId: Scalars['String']['output'];
  packageSize: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserNode;
};

export type ReturnHistoryNodeConnection = {
  __typename?: 'ReturnHistoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReturnHistoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReturnHistoryNode` and its cursor. */
export type ReturnHistoryNodeEdge = {
  __typename?: 'ReturnHistoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReturnHistoryNode>;
};

export type ScanDataPerBusinessNode = {
  __typename?: 'ScanDataPerBusinessNode';
  business?: Maybe<BusinessNode>;
  scanCount?: Maybe<Scalars['Int']['output']>;
  scanCountStatusDestroyed?: Maybe<Scalars['Int']['output']>;
  scanCountStatusOk?: Maybe<Scalars['Int']['output']>;
  scanCountStatusRepair?: Maybe<Scalars['Int']['output']>;
};

export type ScanEventNode = Node & {
  __typename?: 'ScanEventNode';
  approvedReturn?: Maybe<Scalars['Boolean']['output']>;
  bag?: Maybe<BagNode>;
  bagOwner?: Maybe<BusinessNode>;
  bagStatus: ScanEventScanEventBagStatusChoices;
  createdAt: Scalars['DateTime']['output'];
  deviceLatitude?: Maybe<Scalars['Float']['output']>;
  deviceLongitude?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  location?: Maybe<LocationNode>;
  /** This is the raw input data used to scan the bag.This is typically equal to the bag's NFC ID or EPC ID, but canbe something else.If `bag` is None, this field gives the ID of what was scanned, whichmay not be a bag. */
  rawInputData?: Maybe<Scalars['String']['output']>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  shipmentLabelReference?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserNode>;
};

export type ScanEventNodeConnection = {
  __typename?: 'ScanEventNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScanEventNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScanEventNode` and its cursor. */
export type ScanEventNodeEdge = {
  __typename?: 'ScanEventNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScanEventNode>;
};

/** An enumeration. */
export enum ScanEventScanEventBagStatusChoices {
  /** Destroyed */
  Destroyed = 'DESTROYED',
  /** Ok */
  Ok = 'OK',
  /** Repair */
  Repair = 'REPAIR'
}

export type ScanEventsPerDayNode = {
  __typename?: 'ScanEventsPerDayNode';
  scanCount?: Maybe<Scalars['Int']['output']>;
  scanCountStatusDestroyed?: Maybe<Scalars['Int']['output']>;
  scanCountStatusOk?: Maybe<Scalars['Int']['output']>;
  scanCountStatusRepair?: Maybe<Scalars['Int']['output']>;
};

export type UpdateBagInput = {
  /** This is the QR code/NFC tag ID of the chip in the bag. */
  bagId?: InputMaybe<Scalars['String']['input']>;
  /** This is the id of the box the chip was shipped in. */
  boxId?: InputMaybe<Scalars['String']['input']>;
  /** The RFID EPC ID of the chip in the bag. */
  epcId?: InputMaybe<Scalars['String']['input']>;
  /** This is the human readable ID of the bag. It's the the last 6 characters of the bag_id */
  humanReadableId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  retiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  retiredBy?: InputMaybe<Scalars['ID']['input']>;
  retiredReasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** This is the id of the small carton the chip was shipped in. */
  smallCartonId?: InputMaybe<Scalars['String']['input']>;
  /** The RFID TID ID of the chip in the bag. */
  tidId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBagMutation = {
  __typename?: 'UpdateBagMutation';
  bag?: Maybe<BagNode>;
};

export type UpdateBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  co2ReductionPerKiloWaste?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalTown?: InputMaybe<Scalars['String']['input']>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteReductionPerCycle?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBusinessMutation = {
  __typename?: 'UpdateBusinessMutation';
  business?: Maybe<BusinessNode>;
};

/**
 * Called from the frontend after a user has logged in, e.g. via OAuth and a JWT
 * has been returned from the third party.
 *
 * The only purpose of this mutation is to set "last_login" on the user.
 */
export type UpdateLastLoginMutation = {
  __typename?: 'UpdateLastLoginMutation';
  user?: Maybe<UserNode>;
};

export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  closingHour?: InputMaybe<Scalars['Time']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  freightPartner?: InputMaybe<LocationsLocationFreightPartnerChoices>;
  googleLocationId?: InputMaybe<Scalars['String']['input']>;
  hasOpeningHours?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHour?: InputMaybe<Scalars['Time']['input']>;
  openingHours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalTown?: InputMaybe<Scalars['String']['input']>;
  printerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  ratings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  returns?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scanEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Freight partner service location id. */
  servicePointId?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationsLocationTypeChoices>;
  usedCapacity?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateLocationMutation = {
  __typename?: 'UpdateLocationMutation';
  location?: Maybe<LocationNode>;
};

export type UpdateReturnHistoryInput = {
  /** Latitude of the person returning the bag. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location: Scalars['ID']['input'];
  /** Longitude of the person returning the bag. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The scanned ID of the returned package. */
  packageId: Scalars['String']['input'];
  packageSize?: InputMaybe<Scalars['Int']['input']>;
  user: Scalars['ID']['input'];
};

export type UpdateReturnHistoryMutation = {
  __typename?: 'UpdateReturnHistoryMutation';
  returnHistory?: Maybe<ReturnHistoryNode>;
};

export type UpdateScanEventInput = {
  approvedReturn?: InputMaybe<Scalars['Boolean']['input']>;
  bag?: InputMaybe<Scalars['ID']['input']>;
  bagOwner?: InputMaybe<Scalars['ID']['input']>;
  bagStatus?: InputMaybe<ScanEventScanEventBagStatusChoices>;
  deviceLatitude?: InputMaybe<Scalars['Float']['input']>;
  deviceLongitude?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  /** This is the raw input data used to scan the bag.This is typically equal to the bag's NFC ID or EPC ID, but canbe something else.If `bag` is None, this field gives the ID of what was scanned, whichmay not be a bag. */
  rawInputData?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  shipmentLabelReference?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateScanEventMutation = {
  __typename?: 'UpdateScanEventMutation';
  scanEvent?: Maybe<ScanEventNode>;
};

export type UserNode = Node & {
  __typename?: 'UserNode';
  acceptedTerms: Scalars['Boolean']['output'];
  allowMarketing: Scalars['Boolean']['output'];
  business?: Maybe<BusinessNode>;
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  coupons: CouponNodeConnection;
  createdAt: Scalars['DateTime']['output'];
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  hasRegistered: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  location?: Maybe<LocationNode>;
  numberOfApprovedBagShipments?: Maybe<Scalars['Int']['output']>;
  numberOfBagShipments?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberPrefix?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  ratings: RatingNodeConnection;
  retiredBags: BagNodeConnection;
  returns: ReturnHistoryNodeConnection;
  role?: Maybe<UserRole>;
  scanEvents: ScanEventNodeConnection;
  updatedAt: Scalars['DateTime']['output'];
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
};


export type UserNodeCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeRatingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeRetiredBagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeReturnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeScanEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserNodeConnection = {
  __typename?: 'UserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

/** An enumeration. */
export enum UserRole {
  Admin = 'ADMIN',
  MaintenanceUser = 'MAINTENANCE_USER',
  PointUser = 'POINT_USER',
  User = 'USER'
}

/** Specific mutation users in warehouses can use to register a circulated bag. */
export type WarehouseCreateScanEventMutation = {
  __typename?: 'WarehouseCreateScanEventMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  scanEvent?: Maybe<ScanEventNode>;
};

export type DashboardAnalyticsQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type DashboardAnalyticsQuery = { __typename?: 'Query', dashboardAnalytics?: { __typename?: 'DashboardAnalyticsResult', totalBags?: number | null, parcelsCycled?: number | null, totalCo2Reduction?: number | null, totalWasteReduction?: number | null, monthlyStats?: Array<{ __typename?: 'MonthlyReductionResult', month?: string | null, co2Reduction?: number | null, wasteReduction?: number | null } | null> | null } | null };

export type PatchBusiness2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PatchBusinessInput;
}>;


export type PatchBusiness2Mutation = { __typename?: 'Mutation', patchBusiness?: { __typename?: 'PatchBusinessMutation', business?: { __typename?: 'BusinessNode', id: string, wasteReductionPerCycle: number, co2ReductionPerKiloWaste: number } | null } | null };

export type UpdateLastLoginMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastLoginMutationMutation = { __typename?: 'Mutation', updateLastLogin?: { __typename?: 'UpdateLastLoginMutation', user?: { __typename?: 'UserNode', id: string, lastLogin?: any | null } | null } | null };

export type LogMeInMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LogMeInMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginMutation', token?: string | null, user?: { __typename?: 'UserNode', id: string, fullName?: string | null, username: string } | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserNode', id: string, email: string, username: string, fullName?: string | null, createdAt: any, updatedAt: any, business?: { __typename?: 'BusinessNode', id: string, name: string, wasteReductionPerCycle: number, co2ReductionPerKiloWaste: number, scanLocations?: Array<{ __typename?: 'LocationNode', id: string, name?: string | null, formattedAddress: string }> | null } | null } | null };

export type ParcelsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  retired?: InputMaybe<Scalars['Boolean']['input']>;
  cycles?: InputMaybe<Array<InputMaybe<BagCyclesEnum>> | InputMaybe<BagCyclesEnum>>;
  cyclesGt?: InputMaybe<Scalars['Int']['input']>;
  cyclesLt?: InputMaybe<Scalars['Int']['input']>;
  lastScanned?: InputMaybe<Array<InputMaybe<LastScannedAtEnum>> | InputMaybe<LastScannedAtEnum>>;
  lastScannedAtGt?: InputMaybe<Scalars['DateTime']['input']>;
  lastScannedAtLt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ParcelsQuery = { __typename?: 'Query', allBags?: { __typename?: 'BagNodeConnection', edges: Array<{ __typename?: 'BagNodeEdge', node?: { __typename?: 'BagNode', id: string, bagId: string, cycles?: number | null, status?: string | null, createdAt: any, updatedAt: any, lastScannedAt?: any | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type RetireParcelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RetireParcelMutation = { __typename?: 'Mutation', retireBag?: { __typename?: 'RetireBagMutation', bag?: { __typename?: 'BagNode', id: string, retiredAt?: any | null, retiredReasons?: Array<string | null> | null } | null } | null };

export type BusinessQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BusinessQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessNode', id: string, name: string, createdAt: any, updatedAt: any } | null };

export type RegisterScanEventMutationVariables = Exact<{
  bagId: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
}>;


export type RegisterScanEventMutation = { __typename?: 'Mutation', warehouseCreateScanEvent?: { __typename?: 'WarehouseCreateScanEventMutation', scanEvent?: { __typename?: 'ScanEventNode', id: string, rawInputData?: string | null, createdAt: any, bag?: { __typename?: 'BagNode', id: string, bagId: string, cycles?: number | null, humanReadableId?: string | null } | null } | null } | null };

export type ScanHistoryQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ScanHistoryQuery = { __typename?: 'Query', scanEvents?: Array<{ __typename?: 'ScanEventNode', id: string, createdAt: any, rawInputData?: string | null, bag?: { __typename?: 'BagNode', id: string, bagId: string, humanReadableId?: string | null, cycles?: number | null } | null } | null> | null };

export type DeleteScanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScanMutation = { __typename?: 'Mutation', deleteScanEvent?: { __typename?: 'DeleteScanEventMutation', found?: boolean | null, deletedId?: string | null } | null };


export const DashboardAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"businessId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodEnd"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBags"}},{"kind":"Field","name":{"kind":"Name","value":"parcelsCycled"}},{"kind":"Field","name":{"kind":"Name","value":"totalCo2Reduction"}},{"kind":"Field","name":{"kind":"Name","value":"totalWasteReduction"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"co2Reduction"}},{"kind":"Field","name":{"kind":"Name","value":"wasteReduction"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardAnalyticsQuery, DashboardAnalyticsQueryVariables>;
export const PatchBusiness2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PatchBusiness2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatchBusinessInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patchBusiness"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wasteReductionPerCycle"}},{"kind":"Field","name":{"kind":"Name","value":"co2ReductionPerKiloWaste"}}]}}]}}]}}]} as unknown as DocumentNode<PatchBusiness2Mutation, PatchBusiness2MutationVariables>;
export const UpdateLastLoginMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLastLoginMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLastLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLastLoginMutationMutation, UpdateLastLoginMutationMutationVariables>;
export const LogMeInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogMeIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]} as unknown as DocumentNode<LogMeInMutation, LogMeInMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"wasteReductionPerCycle"}},{"kind":"Field","name":{"kind":"Name","value":"co2ReductionPerKiloWaste"}},{"kind":"Field","name":{"kind":"Name","value":"scanLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const ParcelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Parcels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retired"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cycles"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BagCyclesEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cyclesGt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cyclesLt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastScanned"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LastScannedAtEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastScannedAtGt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastScannedAtLt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"retired"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retired"}}},{"kind":"Argument","name":{"kind":"Name","value":"cycles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cycles"}}},{"kind":"Argument","name":{"kind":"Name","value":"cyclesGt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cyclesGt"}}},{"kind":"Argument","name":{"kind":"Name","value":"cyclesLt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cyclesLt"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastScannedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastScanned"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastScannedAtGt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastScannedAtGt"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastScannedAtLt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastScannedAtLt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bagId"}},{"kind":"Field","name":{"kind":"Name","value":"cycles"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastScannedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ParcelsQuery, ParcelsQueryVariables>;
export const RetireParcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetireParcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasons"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retireBag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasons"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"retiredReasons"}}]}}]}}]}}]} as unknown as DocumentNode<RetireParcelMutation, RetireParcelMutationVariables>;
export const BusinessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Business"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<BusinessQuery, BusinessQueryVariables>;
export const RegisterScanEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterScanEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bagId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouseCreateScanEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bagId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bagId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rawInputData"}},{"kind":"Field","name":{"kind":"Name","value":"bag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bagId"}},{"kind":"Field","name":{"kind":"Name","value":"cycles"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<RegisterScanEventMutation, RegisterScanEventMutationVariables>;
export const ScanHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScanHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"-created_at","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rawInputData"}},{"kind":"Field","name":{"kind":"Name","value":"bag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bagId"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableId"}},{"kind":"Field","name":{"kind":"Name","value":"cycles"}}]}}]}}]}}]} as unknown as DocumentNode<ScanHistoryQuery, ScanHistoryQueryVariables>;
export const DeleteScanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteScan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScanEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"found"}},{"kind":"Field","name":{"kind":"Name","value":"deletedId"}}]}}]}}]} as unknown as DocumentNode<DeleteScanMutation, DeleteScanMutationVariables>;